import { createAction, props } from '@ngrx/store';
import { Usuario } from '../../types/usuario.types';
import { MapLayer } from '../projects/projects.types';
import { PublicTokensState, UserPermissionsState } from './auth.reducer';

export const getPublicTokens = createAction(
  '[APP] Get Public Tokens',
  props<{ subdomain: string }>()
);
export const getPublicTokensSuccess = createAction(
  '[Auth API] Get Public Tokens Success',
  props<{ publicTokens: PublicTokensState }>()
);
export const getPublicTokensFail = createAction(
  '[Auth API] Get Public Tokens Fail',
  props<{ error: any }>()
);

export const getOUVLayers = createAction(
  '[Auth API] Get OUV Layers',
  props<{ publicTokens: { authToken: string; tnToken: string } }>()
);
export const getOUVLayersSuccess = createAction(
  '[Auth API] Get OUV Layers Success',
  props<{ layers: MapLayer[] }>()
);
export const getOUVLayersFail = createAction(
  '[Auth API] Get OUV Layers Fail',
  props<{ error: any }>()
);

export const getUserPermission = createAction('[APP] Get User Permission');
export const getUserPermissionSuccess = createAction(
  '[Auth API] Get User Permission Success',
  props<{ permissions: UserPermissionsState }>()
);
export const getUserPermissionFail = createAction(
  '[Auth API] Get User Permission Fail',
  props<{ error: any }>()
);

export const userLogin = createAction(
  '[Login Page] User Login',
  props<{ email: string; password: string }>()
);
export const userLoginSuccess = createAction(
  '[Auth API] User Login Success',
  props<{ user: Usuario }>()
);
export const userLoginFail = createAction(
  '[Auth API] User Login Fail',
  props<{ error: any }>()
);

export const userCheckLogged = createAction('[APP] User Check Logged');
export const userCheckLoggedSuccess = createAction(
  '[APP] User Check Logged Success',
  props<{ user: Usuario }>()
);
export const userCheckLoggedFail = createAction('[APP] User Check Logged Fail');

export const userLogout = createAction('[User Button Menu] User Logout');
